export const GRANDES_ENSEIGNES: string[] = [
  '8 à huit',
  'A2pas',
  'Aldi',
  'Auchan',
  'BBG Market',
  'Bi1',
  "Bio c' Bon",
  'Biocoop',
  'Biomonde',
  'Carrefour',
  'Casino',
  'Cavavin',
  'Coccimarket',
  'Coccinelle',
  'Colruyt',
  'Comptoir des vignes',
  'Cora',
  'De Neuville',
  'Ecomiam',
  'Franprix',
  'G20',
  'Grand Frais',
  'Intercaves',
  'Intermarché',
  'Jeff de Bruges',
  'Kusmi Tea',
  "L'Atelier du Chocolat",
  "L'Eau Vive",
  'La Vie Claire',
  'La Vie Saine',
  'La Vignery',
  'Leader Price',
  'Leclerc',
  'Leonidas',
  'Lidl',
  'Lindt',
  'Super U',
  'Hyper U',
  'Express U',
  'U Super',
  'U Hyper',
  'U Express',
  'Match',
  'Maximarché',
  'Monoprix',
  'Monsieur le Zinc',
  'Naturalia',
  'Naturéo',
  'Netto',
  'Nicolas',
  'Norma',
  'Nous Anti Gaspi',
  'Palais des thés',
  'Petit Casino',
  'Picard',
  'Satoriz',
  'Sherpa',
  'Spar',
  'Supeco',
  'Thiriet',
  'Vival',
]
